"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forbidPageFromCopying = exports.forbidCopyingContent = exports.markCoppiedContent = exports.eventContentProtected = exports.EVENT_CONTENT_PROTECTED = exports.FORBIDDEN_FROM_COPYING = exports.PROTECTED_FROM_COPY_ATTR = void 0;
exports.PROTECTED_FROM_COPY_ATTR = 'data-cp-protected';
exports.FORBIDDEN_FROM_COPYING = 'data-cp-forbidden';
exports.EVENT_CONTENT_PROTECTED = 'cp-protected';
const eventContentProtected = () => new CustomEvent(exports.EVENT_CONTENT_PROTECTED);
exports.eventContentProtected = eventContentProtected;
function markCoppiedContent(contentCustomSelector, mark) {
    const DEFAULT_MARK = ` Source: ${window.location.href.split('?')[0]}`;
    const selector = contentCustomSelector !== null && contentCustomSelector !== void 0 ? contentCustomSelector : `[${exports.PROTECTED_FROM_COPY_ATTR}]`;
    const contentToMark = Array.from(document.querySelectorAll(selector));
    document.body.addEventListener('copy', onCopy);
    document.body.addEventListener('cut', onCopy);
    window.dispatchEvent((0, exports.eventContentProtected)());
    function onCopy(event) {
        var _a;
        const target = event.target;
        const selection = document.getSelection();
        if (['input', 'textarea'].includes(target.tagName.toLocaleLowerCase()))
            return;
        const shouldAddSource = (contentToMark.includes(target) ||
            contentToMark.some(node => selection === null || selection === void 0 ? void 0 : selection.containsNode(node)) ||
            contentToMark.some(node => node.contains(selection.anchorNode)) ||
            Boolean(target === null || target === void 0 ? void 0 : target.querySelector(selector)));
        if (!shouldAddSource)
            return;
        (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData("text/plain", `${(selection === null || selection === void 0 ? void 0 : selection.toString()) || ''} ${mark !== null && mark !== void 0 ? mark : DEFAULT_MARK}`);
        event.preventDefault();
    }
    function destructor() {
        document.body.removeEventListener('copy', onCopy);
        document.body.removeEventListener('cut', onCopy);
    }
    return destructor;
}
exports.markCoppiedContent = markCoppiedContent;
function forbidCopyingContent(contentCustomSelector) {
    const selector = contentCustomSelector !== null && contentCustomSelector !== void 0 ? contentCustomSelector : `[${exports.PROTECTED_FROM_COPY_ATTR}]`;
    const contentToMark = Array.from(document.querySelectorAll(selector));
    document.body.addEventListener('copy', onCopy);
    document.body.addEventListener('cut', onCopy);
    window.addEventListener('contextmenu', onContextmenu, false);
    window.addEventListener('keydown', onDevToolsOpen);
    document.oncontextmenu = function () {
        return false;
    };
    window.dispatchEvent((0, exports.eventContentProtected)());
    function onDevToolsOpen(event) {
        if (tryingOpenDevtool(event))
            event.preventDefault();
    }
    function onCopy(event) {
        const target = event.target;
        const selection = document.getSelection();
        if (['input', 'textarea'].includes(target.tagName.toLocaleLowerCase()))
            return;
        const shouldForbidCopying = (contentToMark.includes(target) ||
            contentToMark.some(node => selection === null || selection === void 0 ? void 0 : selection.containsNode(node)) ||
            contentToMark.some(node => node.contains(selection.anchorNode)) ||
            Boolean(target === null || target === void 0 ? void 0 : target.querySelector(selector)));
        if (!shouldForbidCopying)
            return;
        event.preventDefault();
    }
    function onContextmenu(event) {
        event.preventDefault();
    }
    function destructor() {
        document.body.removeEventListener('copy', onCopy);
        document.body.removeEventListener('cut', onCopy);
        window.removeEventListener('contextmenu', onContextmenu, false);
        window.removeEventListener('keydown', onDevToolsOpen);
        document.oncontextmenu = null;
    }
    return destructor;
}
exports.forbidCopyingContent = forbidCopyingContent;
function forbidPageFromCopying(resetEvent = exports.EVENT_CONTENT_PROTECTED) {
    document.body.addEventListener('copy', onCopy);
    document.body.addEventListener('cut', onCopy);
    window.addEventListener('contextmenu', onContextmenu, false);
    window.addEventListener('keydown', onDevToolsOpen);
    document.oncontextmenu = function () {
        return false;
    };
    if (resetEvent) {
        window.addEventListener(resetEvent, destructor);
    }
    function onDevToolsOpen(event) {
        if (tryingOpenDevtool(event))
            event.preventDefault();
    }
    function onCopy(event) {
        event.preventDefault();
    }
    function onContextmenu(event) {
        event.preventDefault();
    }
    function destructor() {
        document.body.removeEventListener('copy', onCopy);
        document.body.removeEventListener('cut', onCopy);
        window.removeEventListener('contextmenu', onContextmenu, false);
        window.removeEventListener('keydown', onDevToolsOpen);
        document.oncontextmenu = null;
    }
    return destructor;
}
exports.forbidPageFromCopying = forbidPageFromCopying;
function tryingOpenDevtool(event) {
    const code = event.code;
    const ctrlPressed = event.metaKey || event.ctrlKey;
    const shiftPressed = event.shiftKey;
    const altPressed = event.altKey;
    return (event.code === 'F12' ||
        (ctrlPressed && altPressed && code === 'KeyI') ||
        (ctrlPressed && altPressed && code === 'KeyJ') ||
        (ctrlPressed && shiftPressed && code === 'KeyJ') ||
        (ctrlPressed && altPressed && code === 'KeyC') ||
        (ctrlPressed && shiftPressed && code === 'KeyC') ||
        (ctrlPressed && shiftPressed && code === 'KeyI') ||
        (ctrlPressed && altPressed && code === 'KeyU') ||
        (ctrlPressed && code === 'KeyU'));
}
